module.exports = __webpack_public_path__ + "img/faede7c.png";